import { Routes } from '@angular/router';
import { TREND_ROUTES } from './admtrends/admtrends.routes';
import { AdmtrendsComponent } from './admtrends/admtrends.component';
import { AdmsectionComponent } from './shared/admsection/admsection.component';
import { ADMSECTION_ROUTES } from './shared/admsection/admsection.routes';
import { AdmsubsectionComponent } from './shared/admsubsection/admsubsection.component';
import { ADMSUBSECTION_ROUTES } from './shared/admsubsection/admsubsection.router';
import { AdmgraphicComponent } from './shared/admgraphic/admgraphic.component';
import { ADMGRAPHIC_ROUTES } from './shared/admgraphic/admgraphic.routes';
import { AdmbiblioComponent } from './shared/admbiblio/admbiblio.component';
import { ADMBIBLIO_ROUTES } from './shared/admbiblio/admbiblio.routes';
import { ADMPRIMARY_ROUTES } from './shared/admprimarysource/admprimarysource.routes';
import { AdmrisksComponent } from './admrisks/admrisks.component';
import { RISK_ROUTES } from './admrisks/amdrisks.routes';
import { AdmopportunitiesComponent } from './admopportunities/admopportunities.component';
import { OPORT_ROUTES } from './admopportunities/admopportunities.routes';
import { AdmmegaComponent } from './admmega/admmega.component';
import { MEGA_ROUTES } from './admmega/admmega.routes';
import { AdmsceneComponent } from './admscene/admscene.component';
import { SCENE_ROUTES } from './admscene/admscene.routes';
import { AdmsignalComponent } from './admsignal/admsignal.component';
import { SIGNAL_ROUTES } from './admsignal/admsignal.routes';
import { AdmnewsComponent } from './admnews/admnews.component';
import { ADMNEWS_ROUTES } from './admnews/admnews.routes';
import { AdmmeetingComponent } from './admmeeting/admmeeting.component';
import { ADMMEET_ROUTES } from './admmeeting/admmeeting.routes';
import { AdmcontentComponent } from './shared/admcontent/admcontent.component';
import { ADMCONTENT_ROUTES } from './shared/admcontent/admcontent.routes';
import { AdmprimaryforceComponent } from './admprimaryforce/admprimaryforce.component';
import { PFORCE_ROUTES } from './admprimaryforce/admprimaryforce.routes';
import { AdmtechComponent } from './admtech/admtech.component';
import { TECH_ROUTES } from './admtech/admtech.routes';
import { AdmtematicsComponent } from './admtematics/admtematics.component';
import { TEMATICA_ROUTES } from './admtematics/tematica.routes';
import { AdmpublicationsComponent } from './admpublications/admpublications.component';
import { ADMPUBLICATIONS_ROUTES } from './admpublications/admpublications.routes';
import { AdmpodcastComponent } from './admpodcast/admpodcast.component';
import { ADMPODCAST_ROUTES } from './admpodcast/admpodcast.routes';
import { AdmnetworksComponent } from './admnetworks/admnetworks.component';
import { ADMNETWORKS_ROUTES } from './admnetworks/admnetworks.routes';
import { AdmforumsComponent } from './admforums/admforums.component';
import { ADMFORUMS_ROUTES } from './admforums/admforums.routes';
import { AdmuserComponent } from './admuser/admuser.component';
import { ADMUSERS_ROUTES } from './admuser/user.router';
import { AdmreportComponent } from './admreport/admreport.component';
import { AdmcommentComponent } from './admcomment/admcomment.component';
import { ADMCOMMENT_ROUTES } from './admcomment/admcomment.routes';
import { AdmsheetComponent } from './admsheet/admsheet.component';
import { ADMSHEET_ROUTES } from './admsheet/admsheet.router';
import { ADMSUSCRIPTION_ROUTES } from './admsuscription/admpodcast.routes';

export const ADM_ROUTES: Routes = [
    { path: 'seccion', component: AdmsectionComponent, children: ADMSECTION_ROUTES },
    { path: 'subseccion', component: AdmsubsectionComponent, children: ADMSUBSECTION_ROUTES },
    { path: 'grafico', component: AdmgraphicComponent, children: ADMGRAPHIC_ROUTES },
    { path: 'bibliografia', component: AdmbiblioComponent, children: ADMBIBLIO_ROUTES },
    { path: 'fuente', component: AdmgraphicComponent, children: ADMPRIMARY_ROUTES },
    { path: 'contenido', component: AdmcontentComponent, children: ADMCONTENT_ROUTES },
    /* --------------------------------------------------------------------------- */
    { path: 'tendencia', component: AdmtrendsComponent, children: TREND_ROUTES },
    { path: 'riesgo', component: AdmrisksComponent, children: RISK_ROUTES },
    { path: 'oportunidad', component: AdmopportunitiesComponent, children: OPORT_ROUTES },
    { path: 'megatendencia', component: AdmmegaComponent, children: MEGA_ROUTES },
    { path: 'escenario', component: AdmsceneComponent, children: SCENE_ROUTES },
    { path: 'evento', component: AdmsignalComponent, children: SIGNAL_ROUTES },
    { path: 'actualidad', component: AdmnewsComponent, children: ADMNEWS_ROUTES },
    { path: 'encuentro', component: AdmmeetingComponent, children: ADMMEET_ROUTES },
    { path: 'fuerza', component: AdmprimaryforceComponent, children: PFORCE_ROUTES },
    { path: 'tecnologia', component: AdmtechComponent, children: TECH_ROUTES },
    { path: 'tematica', component: AdmtematicsComponent, children: TEMATICA_ROUTES },
    { path: 'publicacion', component: AdmpublicationsComponent, children: ADMPUBLICATIONS_ROUTES },
    { path: 'podcast', component: AdmpodcastComponent, children: ADMPODCAST_ROUTES },
    { path: 'redes', component: AdmnetworksComponent, children: ADMNETWORKS_ROUTES },
    { path: 'foros', component: AdmforumsComponent, children: ADMFORUMS_ROUTES },
    { path: 'usuarios', component: AdmuserComponent, children: ADMUSERS_ROUTES },
    { path: 'comentarios', component: AdmcommentComponent, children: ADMCOMMENT_ROUTES },
    { path: 'suscripcion', component: AdmforumsComponent, children: ADMSUSCRIPTION_ROUTES },
    /*------------------------------------------------------------------------------ */
    { path:'reporte', component: AdmreportComponent },

    { path: 'fichas', component: AdmsheetComponent, children: ADMSHEET_ROUTES },
    { path: '**', pathMatch: 'full', redirectTo: 'tendencia' }
];